import styled, { css } from 'styled-components'
import media from 'styled-media-query'

const sizes = {
  extraLarge: 1400,
  large: 1200,
  medium: 700,
  small: 600
}
const Section = styled.section`
  .header-text {
    font-weight: 700;
    ${media.lessThan('medium')`
  text-align: left;
  
  `}
  }
  background: white;
  ${(props) =>
    props.gray
      ? css`
          background: #f7f7f7;
        `
      : props.cream
      ? css`
          background: #ffffff;
        `
      : props.transparent
      ? css`
          background: transparent;
        `
      : ''}
  ${(props) =>
    props.charcoal
      ? css`
          background: ${(props) => props.theme.charcoal};
          color: white;
          & * {
            color: white;
          }
        `
      : ''} 
      ${(props) =>
    props.rpDark
      ? css`
          background: ${(props) => '#394E66'};
          color: white;
          & * {
            color: white;
          }
        `
      : ''} 
      ${(props) =>
    props.fluid
      ? css`
          max-width: none;
        `
      : css`
          margin-left: auto;
          margin-right: auto;
          max-width: ${(props) => sizes[props.size]}px;

          & > div > h1 {
            max-width: 900px;
            ${'' /* margin: 0 auto; */}
          }

          img {
            max-width: 950px;
            margin-left: auto;
            margin-right: auto;
            display: block;
          }
          span > img {
            display: initial;
          }
          margin-left: auto;
          margin-right: auto;
          padding: ${(props) => (props.padding ? props.padding : '20px 30px')};
          ${media.lessThan('medium')`
          padding: 20px 1rem;
        `}
          ${(props) =>
            props.mobile == 'noPadding' ? 'padding: 20px 0px;' : ''}
        `};
  ${(props) => (props.transparent ? 'background: transparent;' : '')}
`

export default Section
